import { estadoDeCobro } from './cobros';

const DIAS_POR_PERIODO = { daily: 1, weekly: 7, biweekly: 15, monthly: 30 };

// Reparte los préstamos activos según CÓMO están atrasados, que es lo que
// cambia la forma de cobrarles.
//
// Los días que se muestran son días de ATRASO —desde la fecha en que le venció
// y no pagó—, no días desde el último abono. Antes se usaba lo segundo, y un
// cliente que había pagado puntual el 5 de julio aparecía con «36 días» el 10
// de agosto cuando llevaba 5. Su dueño llamó diciendo «pero si ya pagó», y
// tenía razón.
export function clasificarMora(prestamos, hoy = new Date()) {
  const ahora = [];
  const nunca = [];
  const dejaron = [];
  const deMenos = [];

  prestamos.forEach(p => {
    const cobro = estadoDeCobro(p, p.pagos || [], hoy);
    if (cobro.situacion === 'al_dia' || cobro.situacion === 'vence_manana') return;

    const periodo = DIAS_POR_PERIODO[p.frequency] || 30;
    const fila = { ...p, periodo, cobro, estado: cobro.estado,
                   diasAtraso: cobro.diasAtraso };

    // ── A quién se le vence AHORA ──
    //
    // Este grupo existe porque la lista se ahogaba. En la cartera real hay 96
    // préstamos sin un solo abono, algunos desde 2022: al que le vence hoy
    // quedaba enterrado entre gente que no paga hace tres años, y el dueño
    // decía «no me los muestra» cuando sí estaban — invisibles entre ciento y
    // pico de nombres.
    //
    // El límite es el periodo del propio préstamo: en uno mensual, un atraso de
    // hasta un mes todavía es cobrable con una llamada; en uno diario, un día.
    // Pasado eso deja de ser la tarea de hoy y pasa a ser cobranza.
    if (cobro.diasAtraso <= periodo) {
      ahora.push(fila);
      return;
    }

    if (!p.last_payment) {
      nunca.push(fila);
      return;
    }

    // Quien abonó dentro del último periodo pero sigue debiendo: paga puntual y
    // de menos. Es el que más fácil se escapa —nunca deja de pagar— y se cobra
    // distinto que el que desapareció: a este hay que subirle la cuota, no
    // buscarlo.
    const diasDesdeAbono = p.dias_sin_pagar || 0;
    (diasDesdeAbono <= periodo ? deMenos : dejaron).push(fila);
  });

  const porAtraso = (a, b) => b.diasAtraso - a.diasAtraso;
  // Lo que de verdad debe hoy: en cuota fija es lo atrasado, no el interés
  // pendiente del total —que en ese modelo no mide atraso ninguno—.
  const debeAhora = (f) => f.estado.modalidad === 'cuota_fija'
    ? f.estado.atrasoEnPlata
    : f.estado.interesPendiente;
  const porDeuda = (a, b) => debeAhora(b) - debeAhora(a);
  return {
    // Primero los del día: es lo único de esta pantalla que se puede cobrar hoy.
    ahora: ahora.sort(porDeuda),
    nunca: nunca.sort(porAtraso),
    dejaron: dejaron.sort(porAtraso),
    deMenos: deMenos.sort(porDeuda)
  };
}

// Resumen para el aviso de la portada: cuántos hay y cuánto suman.
export function resumenDeMora(prestamos = [], hoy = new Date()) {
  const g = clasificarMora(prestamos, hoy);
  const todos = [...g.ahora, ...g.dejaron, ...g.nunca, ...g.deMenos];
  return {
    ...g,
    total: todos.length,
    // Los que llevan más tiempo debiendo, que son a los que hay que llamar
    // antes de que se enfríen.
    urgentes: todos.slice().sort((a, b) => b.diasAtraso - a.diasAtraso),
    interesSinCobrar: todos.reduce((s, f) => s + Math.max(0,
      f.estado.modalidad === 'cuota_fija' ? f.estado.atrasoEnPlata
                                          : f.estado.interesPendiente), 0),
    // Cuántos de ellos vencen justo hoy: esos todavía se pueden cobrar a tiempo.
    venceHoy: todos.filter(f => f.cobro.situacion === 'vence_hoy').length,
  };
}
